import './App.css';
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import SamoyedAppBar from './SamoyedAppBar/SamoyedAppBar';
import HomePage from './HomePage/HomePage';

function App() {
  return (

    <React.Fragment>
      <AppBar position="fixed">
        <SamoyedAppBar/>
      </AppBar>
      <Toolbar />
      <HomePage/>
    </React.Fragment>
  );
}

export default App;
